export const environment = {
  production: true,
  myGazeApiUrl: 'ws://127.0.0.1:8080',
  modelUrl: '/assets/models',
  consoleAppURL: `${location.origin}/console_app.zip`,
  FFmpegURL: '/FFmpeg_source.zip'
};
